module.exports = __webpack_public_path__ + "img/List1.70135581.png";